import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=0e1608ff&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./uservideo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1608ff')) {
      api.createRecord('0e1608ff', component.options)
    } else {
      api.reload('0e1608ff', component.options)
    }
    module.hot.accept("./MainView.vue?vue&type=template&id=0e1608ff&", function () {
      api.rerender('0e1608ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/userVideo/MainView.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/userVideo/MainView.vue
// module id = A3ot
// module chunks = 0